const API_BASE_URL = process.env.BASE_URL

export const SERVICE_COMPANY = {
    SWITCH_SERVICE_COMPANY: API_BASE_URL + "/user/me/switch-service-company/",
}
